import React, { Fragment, useState } from 'react';
import { useRouter } from 'next/router';
import { Button } from '@BICE_Vida/components';

import { Col, Container, Row } from '../../../designSystem/Container/Container';
import Text from '../../../designSystem/Text';
import SearchBar from '../../../designSystem/SearchBar';
import { SearchBarOptionsT } from '../../../designSystem/SearchBar/SearchBar';
import FullBanner from '../../FullBanner';
import HelpDeskCategoryCard from './HelpDeskCategoryCard';
import FooterSimple from '../../FooterSimple';

import styles from './HelpDesk.module.scss';

import { helpDeskTexts } from '../../../utils/generalTexts';
import componentsId from '../../../utils/componentsId';
import { searchOverQuestion } from '../../../utils/textFilter';

import { CAT } from '../../../utils/assets';
import routes from '../../../utils/routes';

type HelpDeskCategoriesT = {
  categories: HelpDeskCategory[];
};

const HelpDeskCategories = ({ categories }: HelpDeskCategoriesT) => {
  const router = useRouter();
  const options: SearchBarOptionsT[] = [];

  const [searchInput, setSearchInput] = useState<string>('');
  const [searchOptions, setSearchOptions] = useState<SearchBarOptionsT[]>([]);

  const filterOptions = (value: any, input: any) => searchOverQuestion(value.title, input);

  const handleClick = (data: HelpDeskCategory, value: HelpDeskQuestion) => {
    options.push({
      text: value.title,
      onClick: () => {
        router.push(`${routes.helpDesk}/${data.categoryKeyword}/${value.keyword}`);
      },
    });
  };

  const onChangeSearchHandler = (event: any) => {
    const newSearchInput = event.target.value;
    setSearchInput(newSearchInput);

    if (newSearchInput.length > 2) {
      categories.map((data: HelpDeskCategory) => {
        data.questions
          .filter((value: HelpDeskQuestion) => filterOptions(value, newSearchInput))
          .map((value) => {
            handleClick(data, value);
          });
      });

      setSearchOptions(options);
    } else {
      setSearchOptions([]);
    }
  };

  const onPressEnterSearchHandler = (search: string) =>
    router.push({
      pathname: routes.helpDeskSearch,
      query: {
        search,
      },
    });

  const onContantHandler = () => {
    router.push(routes.helpDeskContact);
  };

  return (
    <Fragment>
      <div className={styles.help_desk_home}>
        <div className={styles.help_desk_home_hero}>
          <Text text={helpDeskTexts.home.title} customClass={styles.help_desk_home_title} />
          <div className={styles.help_desk_home_hero_circle_top} />
          <div className={styles.help_desk_home_hero_circle_bottom_right} />
          <div className={styles.help_desk_home_hero_circle_bottom_left} />

          <SearchBar
            className={styles.help_desk_home_searchbar}
            size="large"
            value={searchInput}
            onChange={onChangeSearchHandler}
            options={searchOptions}
            onPressEnter={onPressEnterSearchHandler}
          />
        </div>

        <Container className={styles.help_desk_home_categories}>
          <Row justify="center">
            <Col sm={12} md={12} lg={11} xl={10} className={styles.help_desk_home_categories_col}>
              {categories.map((category: HelpDeskCategory, index: number) => (
                <HelpDeskCategoryCard key={`help_desk_category_${index}`} category={category} />
              ))}
            </Col>
          </Row>
        </Container>

        <FullBanner theme="light">
          <div className={styles.help_desk_home_banner}>
            <div>
              <Text
                text={helpDeskTexts.home.bannerTitle}
                customClass={styles.help_desk_home_banner_title}
              />
              <Text
                text={helpDeskTexts.home.bannerDescription}
                customClass={styles.help_desk_home_banner_description}
              />
              <Button
                id={componentsId.helpDesk.home.bannerBtn}
                text={helpDeskTexts.home.bannerBtn}
                size="medium"
                className={styles.help_desk_home_banner_button}
                onClick={onContantHandler}
              />
            </div>
            <img
              src={CAT.CAT_FULL_CALL_CENTER}
              alt="bicevida centro de ayuda"
              className={styles.help_desk_home_banner_img}
            />
          </div>
        </FullBanner>
      </div>

      <FooterSimple />
    </Fragment>
  );
};

export default HelpDeskCategories;
